let baseUrl = ''

if(process.env.NODE_ENV === 'development') {
  baseUrl = '/urlsec'
} else if(location.hostname.includes('sparta')) {
  baseUrl = '//cgiurlsec.sparta.html5.qq.com'
} else {
  baseUrl = '//cgi.urlsec.qq.com'
}

export default {
  // 申述表单相关
  validUrlAsync: `${baseUrl}/index.php?m=url&a=validUrl`,
  uploadImg: `${baseUrl}/index.php?m=uploadFile&a=upload`,
  postUrlComplain: `${baseUrl}/index.php?m=urlComplain&a=addItem`,
  getWebsiteClass: `${baseUrl}/index.php?m=url&a=getWebsiteClass`,
  getUrlComplainStatus: `${baseUrl}/index.php?m=urlComplain&a=getComplainStatus`,
  addCert: `${baseUrl}/index.php?m=urlComplain&a=reSubmitCertificate`,
  checkSiteIdentify: `${baseUrl}/index.php?m=url&a=checkSiteIdentify`,
  identifySite: `//siteident.urlsec.qq.com/identifySite`,
  identifySiteLater: `${baseUrl}/identification/index.php?m=url&a=identifySiteLater`,

  checkWechatUser: '/wechat/urlcomplain/checkWechatUser',

  getSmsCode: `${baseUrl}/index.php?m=urlComplain&a=getSmsCode`,
  checkSmsCode: `${baseUrl}/index.php?m=url&a=checkSmsCode`,
}



// WEBPACK FOOTER //
// ./src/cgi.js